<template>
  <div class="base-modal-wrapper">
    <div class="base-modal-backdrop" @click="onBackdropClick"></div>
    <div :style="{width:containerWidth}" class="base-modal-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
   props: {
    containerWidth: {
      type: String,
      default: ''
    }
  },
  methods: {
    onBackdropClick() {
      this.$emit('backdropClick');
    }
  },
  mounted() {
    window.document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    window.document.body.style.overflow = 'initial';
  }
}
</script>

<style scoped>
.base-modal-wrapper {

}

.base-modal-backdrop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #ededed;
  opacity: 0.1;

  z-index: 10;
}

.base-modal-content {
  z-index: 15;
  width: 57vh;
  position: fixed;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);

  padding: 2.3vh;
  background-color: #1d1d1b;
  color: #ededed;
  border-radius: 1.5vh;
}

.base-modal-content-large {
  width: 90vw;
}
</style>